@if (question) {
  <label>{{ question.question_text }}</label>
  <div class="ranking" cdkDropList (cdkDropListDropped)="drop(question.answer_order, $event)" data-testid="ranking-list">
    @for (answer of question.answer_order; track answer) {
      <div class="answer" cdkDrag>
        <mat-icon>drag_indicator</mat-icon>
        <div >{{answer.answer_text}}</div>
      </div>
    }
  </div>

  <div style="margin-top: 1rem; margin-left: 1rem; display: flex; align-items: center; gap: 1rem">
    <lib-button (click)="saveAnswer()" data-testid="ranking-next-button">Next</lib-button>
    <div class="saved" *ngIf="question.user_answer_ind === 1">Saved</div>
  </div>
}